<flx-modal class="flx-ds dark">
  <div
    class="flx-modal-title text-white"
    flxModalHeaderTitle
  >
    Additional Feedback
  </div>
  <div
    class="flx-modal-subtitle text-neutral-400"
    flxModalHeaderSubtitle
  >
    Let us know what we can improve about the response:
  </div>

  <div class="flx-modal-body">
    <div class="w-full">
      <div class="flex w-full">
        <flx-label class="grow flx-ds mandatory">Select an issue</flx-label>
      </div>
      <flx-choice-group
        [direction]="'column'"
        class="flex w-full mt-1 flx-ds"
      >
        @for (reason of feedbackReasons; track reason) {
          <flx-radio
            [clear]="true"
            [value]="reason"
            [formControl]="$any(feedbackFG.get('reason'))"
            [checked]="feedbackFG.get('reason').value === reason"
          >
            <flx-label>{{ reason }}</flx-label>
          </flx-radio>
        }
      </flx-choice-group>
    </div>

    <flx-textarea class="flx-ds flex w-full">
      <div class="flex w-full">
        <flx-label class="grow flx-ds mb-1">Extra details (optional)</flx-label>
      </div>

      <textarea
        [formControl]="$any(feedbackFG.get('message'))"
        class="w-full"
        placeholder="Add feedback..."
        flxTextarea
        type="text"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        cdkAutosizeMaxRows="3"
      ></textarea>
    </flx-textarea>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        flxButton
        type="button"
      >
        Cancel
      </button>
      <button
        [disabled]="feedbackFG.invalid"
        (click)="submitFeedback()"
        class="flx-ds primary"
        flxButton
        type="button"
      >
        Send Feedback
      </button>
    </div>
  </div>
</flx-modal>
